import React, { useState } from 'react';
import { FileText, TrendingUp, DollarSign, Layers, Users, MessageCircle } from 'lucide-react';

const projectIcons = [FileText, TrendingUp, DollarSign, Layers, Users, MessageCircle];

const projectsData = [
  { 
    id: 1, 
    title: 'Document Intelligence', 
    description: 'Advanced OCR and custom data extraction for automated content auditing.', 
    details: 'This system leverages proprietary OCR models to ingest marketing brochures and technical documents. It automatically reviews content against brand guidelines and regulatory requirements, refining text and layout suggestions with high precision.',
    videoUrl: '/videos/document_intelligence_gwr_video_mvp.mp4'
  },
  { 
    id: 2, 
    title: 'SalesProcess Automation', 
    description: 'AI-driven lead qualification and sales workflow optimization.', 
    details: 'Our Sales Automation engine integrates with your CRM to automate repetitive tasks, from initial outreach to follow-up scheduling. It derives deep behavioral insights from prospect interactions to predict conversion probabilities and optimize sales strategies.',
    videoUrl: '/videos/sales_process_automation_gwr_video_mvp.mp4' 
  },
  { 
    id: 3, 
    title: 'Financial Copilot', 
    description: 'A digital CFO for autonomous accounting and financial oversight.', 
    details: 'This copilot manages the entire accounts team workflow, including real-time reconciliation, tax compliance, and cash flow forecasting. It provides agentic financial advice, identifying cost-saving opportunities and ensuring fiscal integrity.',
    videoUrl: '/videos/financial_copilot_gwr_video_mvp.mp4'
  },
  { 
    id: 4, 
    title: 'ERP Copilot', 
    description: 'Agentic ERP interface for natural language resource management.', 
    details: 'An intelligent layer over your ERP system that allows users to manage inventory, procurement, and supply chain logistics entirely via chat. It handles complex queries and executes multi-step operations autonomously.',
    videoUrl: '/videos/erp_copilot_gwr_video_mvp.mp4'
  },
  { 
    id: 5, 
    title: 'HRMS Copilot', 
    description: 'AI-managed employee lifecycle and HR operations.', 
    details: 'Similar to our ERP solution, this agent manages payroll, attendance, and employee records through an intuitive chat interface. It automates onboarding/offboarding and handles employee queries with personalized, policy-aware responses.',
    videoUrl: '/videos/hrms_copilot_gwr_video_mvp.mp4'
  },
  { 
    id: 6, 
    title: 'WhatsApp Automation', 
    description: 'Managed AI communication for scalable customer engagement.', 
    details: 'An end-to-end automation suite for WhatsApp that handles customer support, transaction notifications, and marketing campaigns. It uses advanced NLP to resolve queries and manage complex customer journeys in real-time.',
    videoUrl: '/videos/whatsapp_automation_gwr_video_mvp.mp4'
  },
];

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section id="projects" style={{
      padding: '4rem 0',
      backgroundColor: '#0A0A0A',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Work In Progress Background Animation */}
      <div className="work-progress-animation-bg">
        <div className="scroll-line-bg">
          <div className="scroll-content-bg">
            ❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯
          </div>
        </div>
        <div className="scroll-line-bg">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            9876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210
          </div>
        </div>
        <div className="scroll-line-bg">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress
          </div>
        </div>
        <h1 className="work-progress-text-bg">WORK IN PROGRESS</h1>
        <div className="scroll-line-bg right">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress
          </div>
        </div>
        <div className="scroll-line-bg right">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            9876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210
          </div>
        </div>
        <div className="scroll-line-bg">
          <div className="scroll-content-bg">
            ❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯❯
          </div>
        </div>
        <div className="scroll-line-bg">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            9876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210
          </div>
        </div>
        <h1 className="work-progress-text-bg">WORK IN PROGRESS</h1>
        <div className="scroll-line-bg right">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress Work In Progress
          </div>
        </div>
        <div className="scroll-line-bg right">
          <div className="scroll-content-bg" style={{ fontFamily: 'predator' }}>
            9876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210987654321098765432109876543210
          </div>
        </div>
        <div className="scroll-line-bg right">
          <div className="scroll-content-bg">
            ❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮❮
          </div>
        </div>
      </div>

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>

        {/* Section Header */}
        <div className="reveal" style={{ marginBottom: '4.5rem', textAlign: 'center' }}>
          <span className="section-label section-label-dark">
            Our Work
          </span>
          <h2 style={{
            fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
            fontWeight: 800,
            marginBottom: '1rem',
            letterSpacing: '-0.03em',
            lineHeight: 1.1,
            color: '#FFFFFF'
          }}>
            Built for <span style={{ color: 'rgba(255,255,255,0.4)' }}>Impact.</span>
          </h2>
          <p style={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: '1.2rem',
            fontWeight: 300,
            maxWidth: '560px',
            margin: '0 auto'
          }}>
            Real-world AI systems engineered for enterprise performance.
          </p>
        </div>

        {/* Projects Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
          gap: '1.75rem'
        }}>
          {projectsData.map((project, index) => {
            const Icon = projectIcons[index];

            return (
              <div
                key={project.id}
                className="reveal project-card"
                style={{ transitionDelay: `${index * 0.1}s` }}
                onClick={() => setSelectedProject(project)}
              >
                <div
                  className="project-card-inner"
                  style={{
                    background: '#111111',
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '22px',
                    padding: '2.5rem',
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                    overflow: 'hidden',
                    minHeight: '220px',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  {/* Icon */}
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '14px',
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1.5rem',
                    transition: 'all 0.3s ease'
                  }}>
                    <Icon size={22} color="rgba(255,255,255,0.6)" />
                  </div>

                  {/* Title */}
                  <h3 style={{
                    fontSize: '1.35rem',
                    fontWeight: 700,
                    color: '#FFFFFF',
                    marginBottom: '0.75rem',
                    letterSpacing: '-0.02em',
                    lineHeight: 1.3
                  }}>
                    {project.title}
                  </h3>

                  {/* Short Description */}
                  <p style={{
                    color: 'rgba(255,255,255,0.55)',
                    lineHeight: 1.7,
                    fontSize: '0.92rem'
                  }}>
                    {project.description}
                  </p>

                  {/* Click Indicator */}
                  <div style={{
                    marginTop: 'auto',
                    paddingTop: '1.25rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <span style={{
                      fontSize: '0.72rem',
                      fontWeight: 600,
                      color: 'rgba(255,255,255,0.25)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em'
                    }}>
                      Read more
                    </span>
                    <span style={{
                      color: 'rgba(255,255,255,0.25)',
                      fontSize: '0.8rem'
                    }}>
                      ➔
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Details Modal */}
      {selectedProject && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            animation: 'modalFadeIn 0.3s ease-out',
            padding: '1.5rem'
          }}
          onClick={() => setSelectedProject(null)}
        >
          <div 
            className="project-modal-card"
            style={{
              backgroundColor: '#111111',
              border: '1px solid rgba(78, 154, 6, 0.25)',
              borderRadius: '24px',
              width: '90%',
              maxWidth: '600px',
              position: 'relative',
              boxShadow: '0 30px 60px rgba(78, 154, 6, 0.15)',
              animation: 'modalSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Top accent bar */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: 'linear-gradient(90deg, transparent, #4E9A06, transparent)'
            }} />

            {/* Title */}
            <h3 
              className="project-modal-title"
              style={{
                fontSize: '1.8rem',
                fontWeight: 800,
                color: '#FFFFFF',
                marginBottom: '1rem',
                letterSpacing: '-0.02em'
              }}
            >
              {selectedProject.title}
            </h3>

            {/* Summary */}
            <p 
              className="project-modal-desc"
              style={{
                color: 'rgba(255, 255, 255, 0.65)',
                fontSize: '1.05rem',
                lineHeight: 1.6,
                marginBottom: '1.5rem',
                fontWeight: 500
              }}
            >
              {selectedProject.description}
            </p>

            {/* Video Player (If Available) */}
            {selectedProject.videoUrl && (
              <div style={{
                width: '100%',
                borderRadius: '16px',
                overflow: 'hidden',
                marginBottom: '1.5rem',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                backgroundColor: '#000000',
                aspectRatio: '16/9'
              }}>
                <video 
                  src={selectedProject.videoUrl}
                  preload="none"
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                />
              </div>
            )}

            {/* Divider */}
            <div style={{
              width: '100%',
              height: '1px',
              background: 'rgba(255, 255, 255, 0.08)',
              marginBottom: '1.5rem'
            }} />

            {/* Details */}
            <p 
              className="project-modal-details"
              style={{
                color: 'rgba(255, 255, 255, 0.5)',
                fontSize: '0.95rem',
                lineHeight: 1.8,
                marginBottom: '2.5rem'
              }}
            >
              {selectedProject.details}
            </p>

            {/* Actions */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end',
              flexWrap: 'wrap'
            }}>
              <button 
                onClick={() => setSelectedProject(null)}
                style={{
                  padding: '0.75rem 2rem',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  color: '#FFFFFF',
                  borderRadius: '100px',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)'}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        /* Animated grid pattern */
        .projects-grid-bg {
          position: absolute;
          inset: 0;
          z-index: 0;
          pointer-events: none;
          background-image:
            linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
          background-size: 60px 60px;
          animation: gridFade 8s ease-in-out infinite;
        }
        .projects-grid-bg::after {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 50% 0%, rgba(59,130,246,0.04) 0%, transparent 60%);
        }

        /* Work In Progress Background Animation */
        .work-progress-animation-bg {
          position: absolute;
          inset: 0;
          height: 100%;
          opacity: 0.35; /* Subtle background presence */
          z-index: 0;
          pointer-events: none;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          overflow: hidden;
          color: #4E9A06;
          user-select: none;
          padding: 1rem 0;
        }

        .scroll-line-bg { 
          overflow: hidden; 
          white-space: nowrap; 
          width: 100%; 
          border: none; 
          margin: 0.35rem 0;
        }

        .scroll-content-bg {
          display: inline-block; 
          font-size: 2.2rem;
          animation: scroll-left-bg 20s linear infinite;
        }

        .scroll-line-bg.right .scroll-content-bg { 
          animation: scroll-right-bg 20s linear infinite; 
        }

        .work-progress-text-bg {
          font-size: clamp(3rem, 7vw, 5.5rem); 
          margin: 1rem 0;
          color: #4E9A06; 
          font-family: 'taxon', monospace; 
          letter-spacing: 6px;
          font-weight: 900;
          text-align: center;
          opacity: 0.8;
          text-shadow: 0 0 20px rgba(78, 154, 6, 0.4);
        }

        @keyframes scroll-left-bg { 
          0% { transform: translateX(0); } 
          100% { transform: translateX(-50%); } 
        }

        @keyframes scroll-right-bg { 
          0% { transform: translateX(-50%); } 
          100% { transform: translateX(0); } 
        }

        @keyframes pulseDot {
          0% { transform: scale(0.9); opacity: 0.6; }
          50% { transform: scale(1.2); opacity: 1; }
          100% { transform: scale(0.9); opacity: 0.6; }
        }

        .project-modal-card {
          padding: 2.5rem;
          max-height: 85vh;
          overflow-y: auto;
        }

        @media (max-width: 768px) {
          .work-progress-animation-bg {
            opacity: 0.45;
          }
          .work-progress-text-bg {
            font-size: clamp(2.2rem, 9.5vw, 3.8rem) !important;
            letter-spacing: 2px !important;
            margin: 0.5rem 0 !important;
          }
          .scroll-content-bg {
            font-size: 1.55rem !important;
          }
          .scroll-line-bg {
            margin: 0.15rem 0 !important;
          }
          .project-modal-card {
            padding: 1.5rem 1.25rem !important;
            border-radius: 20px !important;
            max-height: 88vh !important;
            width: 95% !important;
          }
          .project-modal-title {
            font-size: 1.35rem !important;
            margin-bottom: 0.5rem !important;
          }
          .project-modal-desc {
            font-size: 0.92rem !important;
            margin-bottom: 0.85rem !important;
          }
          .project-modal-details {
            font-size: 0.88rem !important;
            margin-bottom: 1.25rem !important;
            line-height: 1.6 !important;
          }
        }

        /* Card hover effects */
        .project-card-inner:hover {
          transform: translateY(-4px);
          border-color: rgba(78, 154, 6, 0.2) !important; /* Green glow border on hover */
          background: #121212 !important;
          box-shadow: 0 20px 50px rgba(78, 154, 6, 0.15); /* Green glow shadow */
        }
        .project-card-inner:hover .project-card-number {
          color: rgba(78, 154, 6, 0.3) !important;
          text-shadow: 0 0 10px rgba(78, 154, 6, 0.4);
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          #projects .container > div:last-of-type {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Projects;
